import React from "react";
import ContactForm from "./ContactForm";
import "../App.css";

const SalesRepInfo = ({ salesRep }) => {
  if (!salesRep) {
    return <div>Loading...</div>;
  }

  return (
    <>
    <div className='center'style={{maxWidth:'80vw'}}>
    <div className='featured' style={{backgroundColor:'transparent', border:'0', maxWidth:'80vw', padding:'0rem'}}>
    
    <div className='row' style={{flexDirection:'column'}}>
    <div className='column center' >
      <div className='recruiting-image-wrapper' style={{borderWidth:".2rem" }}>{salesRep.photo && (
        <img className='recruiting-image' src={salesRep.photo} alt={salesRep.name} />
      )}
      </div>
      </div>
      <div className='column center'>
      <div className='inputResultsFinal center' style={{ color:'white', fontSize:'1rem', marginBottom:'1rem'}}>
      <div style={{ color:'#BCD400', fontSize:'1.25rem', fontWeight:'900'}}>{salesRep.name}</div>
      <div style={{ color:'#333', fontWeight:'500'}}>{salesRep.email}</div>
      <div style={{ color:'#333', fontWeight:'500'}}>{salesRep.phone}</div>
      </div>
      
      </div>
      
    </div>
    </div>
    </div>
    </>
  );
};

export default SalesRepInfo;
